import { createSlice } from '@reduxjs/toolkit';
import { makePropertyReducer } from 'store/utils';
import { AuthState } from './types';

const getPropertyReducer = makePropertyReducer<AuthState>();

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    accountId: '',
    isAuthenticated: false,
    isSessionInvalid: false,
  } as AuthState,
  reducers: {
    ...getPropertyReducer('accountId'),
    ...getPropertyReducer('isAuthenticated'),
    ...getPropertyReducer('isSessionInvalid'),
  },
});

export const {
  actions: { setAccountId, setIsAuthenticated, setIsSessionInvalid },
  reducer: authReducer,
} = authSlice;
